import { StyleSheet } from 'react-native';

export const multiOptionCardStyle = theme => {
  return StyleSheet.create({
    chartCardMainContainer: {
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;',
      borderRadius: 18,
      flex: 1,
      padding: 20
    },
    chartCardHeaderContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  });
};
export const tabSwitcherStyle = theme => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      backgroundColor: theme.palette.primaryBackgroundLow,
      padding: 2,
      borderRadius: 18
    },
    tabSwitchItem: {
      paddingVertical: 5,
      paddingHorizontal: 15
    },
    tabSwitchActiveItem: {
      backgroundColor: 'white',
      borderRadius: 18,
      boxShadow: '0px 0px 4px rgba(0,0,0,0.08), -10px -10px 20px rgba(255,255,255,0.9)'
    }
  });
};
export const styles = StyleSheet.create({
  actionPopoverModalContainer: {
    borderRadius: 18,
    backgroundColor: 'white',
    paddingHorizontal: 2,
    boxShadow: 'rgba(0, 0, 0, 0.25) 0px 5px 10px 0px, rgba(0, 0, 0, 0.25) 0px 10px 16px 0px'
  },
  actionPopoverItemContainer: {
    borderBottomWidth: 1,
    borderColor: '#EAF3FF',
    padding: 10
  },
  actionPopoverItemsContainer: {
    paddingHorizontal: 10,
    marginTop: 10
  },
  actionPopupGroupitem: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 6
  }
});
export const dropdownStyling = {
  container: {
    minHeight: 32,
    maxHeight: 32,
    borderRadius: 16,
    borderWidth: 1,
    width: 140,
    minWidth: 200,
    borderColor: '#8F95A4',
    backgroundColor: '#F8F9FA'
  },

  dropDownText: {
    marginEnd: 0
  },
  icon: {
    height: 22
  },
  optionContainer: {
    minWidth: 150,
    maxWidth: 300
  }
};
